import PropTypes from 'prop-types'
import React, { memo, useEffect, useState } from 'react'
import { Select } from 'antd'
import { structure } from '@dofleini/location'

const { Option } = Select
const { MUNICIPALITIES, findProvinceAcronymByMunicipalityCode } = structure

const Municipality = ({
  value,
  multiple,
  canClear,
  maxItems,
  onChange,
  provAcr,
  canSearch,
  autoFill,
  ...props
}) => {
  const [municipalities, setMunicipalities] = useState([])

  useEffect(() => {
    if (provAcr) {
      if (typeof provAcr === 'object') {
        const arr = []
        provAcr.forEach((prov) => {
          arr.push(...(MUNICIPALITIES[prov] || []))
        })
        setMunicipalities(arr)
      } else {
        setMunicipalities(MUNICIPALITIES[provAcr] || [])
      }
      const elements = MUNICIPALITIES[provAcr]
      const province = findProvinceAcronymByMunicipalityCode(value)
      if (!value || province !== provAcr) {
        if (autoFill) {
          onChange && onChange(elements && elements[0]?.code)
        } else {
          onChange && onChange(null)
        }
      }
    }
  }, [value, provAcr, MUNICIPALITIES])

  return (
    <Select
      mode={multiple ? 'multiple' : 'default'}
      allowClear={canClear}
      style={{ minWidth: 150 }}
      maxTagCount={maxItems || 3}
      onChange={onChange}
      defaultValue={value}
      value={value}
      showSearch={canSearch}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      {provAcr &&
        municipalities &&
        municipalities.map((mun) => (
          <Option key={mun.code} value={mun.code}>
            {mun.name}
          </Option>
        ))}
    </Select>
  )
}

export default memo(Municipality)

Municipality.propTypes = {
  canClear: PropTypes.bool,
  canSearch: PropTypes.bool,
  maxItems: PropTypes.number,
  autoFill: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  provAcr: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  value: PropTypes.string
}

Municipality.defaultProps = {
  autoFill: false
}
